export default __webpack_public_path__ + "static/animation-img1-6b6c49e83e9f7ee6f6e7c0c23fc600e2.webp";